import React, { useCallback, useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, FormControlLabel, Grid, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import RtlProvider from "../../../Components/RtlProvider";
import hotelApi from "../../../api/hotelApi";
import { ContextNotification, severitys } from "../../../App";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import helper from "../../../helper";
import cityApi from "../../../api/cityApi";

import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";
import { useMemo } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { NavLink } from "react-router-dom";
import { MdCheck, MdEdit, MdEditSquare } from "react-icons/md";
import DeleteHotelForm from "./DeleteHotelForm";
import { HiMiniSquares2X2, HiXMark } from "react-icons/hi2";
import staticVariablesApi from "../../../api/staticVariablesApi";

const HotelPanel = () => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);
  const [Cities, setCities] = useState([]);
  const [Hotels, setHotels] = useState([]);
  // const [rows, setRows] = useState([]);
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);

  const schema = yup.object().shape({

  });
  const { handleSubmit, formState: { errors }, control, resetField } = useForm({
    defaultValues: {
      cityConsistency: null,
      hotelId: null,
    },
    resolver: yupResolver(schema),
  });
  const onSubmit = (data) => {
    GetData(parseInt(data.cityConsistency), data.hotelId, data.isActive)
  };

  useEffect(() => {
    GetCityDropDown();
    GetData(null, null, true)
  }, [refresh]);
  const GetData = (cityConsistency, hotelId, isActive) => {
    setLoadingRows(true);
    hotelApi.GetForUser(cityConsistency, hotelId, isActive)
      .then((res) => {
        setData(res.data.data)
      })
      .catch((error) => console.log(error))
      .finally(() => setLoadingRows(false));


  }
  const RefreshGrid = (result) => {
    if (result)
      setRefresh(old => !old);
  }
  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        setCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };

  const handleCityChanged = useCallback(async (id) => {
    resetField("hotelId");
    setHotels(null);
    if (id) {
      const hotels = await fetchHotelsByCityConsistency(id);
      setHotels(
        hotels.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    }
  }, []);
  const fetchHotelsByCityConsistency = async (cityConsistency) => {
    try {
      let res = await hotelApi.HotelDropDown(cityConsistency);
      if (res.status == 200) {
      }
      const arr = helper.DictionayToList(res.data.data)
      return arr;
    }
    catch (err) {
      console.error(err);
    }
  };
  const handleHotelChanged = useCallback(async (id) => {
    if (id) {


    }
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'نام',
        size: 100,
      },
      {
        accessorKey: 'cityName',
        header: 'شهر',
        size: 100,
      },
      {
        accessorKey: 'regionTitle',
        header: 'منطقه',
        size: 100,
      },
      {
        accessorKey: 'managerName',
        header: 'مدیر',
        size: 150,
      },
      {
        accessorKey: 'managerPhoneNumber',
        header: 'تلفن مدیر',
        size: 150,
      },
      {
        accessorKey: 'phoneNumber',
        header: 'تلفن',
        size: 150,
      },
      {
        accessorKey: 'priceGroupTitle',
        header: 'گروه قیمتی',
        size: 150,
      },
      {
        accessorKey: 'isActive',
        id: 'isActive',
        header: 'فعال',
        Cell: ({ cell, row }) => (
          row.original.isActive ? <MdCheck size={25} color='green' /> : <HiXMark />
        ),
        size: 100,
        enableSorting: false,
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: {
      sorting: [

      ],
    },
    state: {
      isLoading: loadingRows,
    },
    enableRowSelection: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enablePagination: false,
    enablePagination: false,
    enableSorting: true,
    enableColumnActions: false,

    mrtTheme: (theme) => ({
      baseBackgroundColor: theme.palette.background.default, //change default background color
    }),

    muiTableProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',

      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        backgroundColor: '#86A7FC',
        fontWeight: 'bold',
        textAlign: 'left'
      },
    },
    muiTableBodyCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        textAlign: 'left'
      },
    },
    enableRowActions: true,
    positionActionsColumn: 'last',
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: '', //change header text
        size: 300, //make actions column wider

      },
    },
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
        {
          AccessControl.checkPermissions(userPermissions, ["Hotel:Edit"]) ?
            <Tooltip title="ویرایش" placement="top">
              <IconButton disabled={row.original.isDeleted}
                component={NavLink} to={`/dashboard/Hotel/edit/${row.original.id}`} sx={{ color: 'IconColor.main' }}><MdEditSquare />
              </IconButton></Tooltip>
            : <></>
        }
        {
          AccessControl.checkPermissions(userPermissions, ["HotelStructure:List"]) ?
            <Tooltip title="ساختار" placement="top">

              <IconButton
                component={NavLink} to={`/dashboard/HotelStructure/List/${row.original.id}`} sx={{ color: 'IconColor.main' }}><HiMiniSquares2X2 />
              </IconButton></Tooltip>
            : <></>
        }
        {
          AccessControl.checkPermissions(userPermissions, ["HotelStructure:Delete"]) &&
          <DeleteHotelForm id={row.original.id} refreshGrid={RefreshGrid} />
        }
      </Box>
    ),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <RtlProvider>
        <Typography component="h1" variant="h5" mb={2}>
          لیست هتل
        </Typography>
        <Grid container spacing={1} mb={2}>

          <Grid item xs={12} sm={2}>
            <RHFAutocomplete
              control={control}
              options={Cities ?? []}
              name="cityConsistency"
              placeholder="شهر"
              onChange={handleCityChanged}
              style={{
                border: "none",
                padding: 0
              }}
            />

          </Grid>
          <Grid item xs={12} sm={2}>
            <RHFAutocomplete
              control={control}
              options={Hotels ?? []}
              name="hotelId"
              placeholder="هتل"
              onChange={handleHotelChanged}
              disabled={Cities === null}
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <FormControlLabel
              control={
                <Controller
                  name="isActive"
                  control={control}
                  defaultValue={true}
                  render={({ field: { value, ref, ...field } }) => (
                    <Checkbox
                      {...field}
                      inputRef={ref}
                      checked={!!value}
                      color="primary"
                      size={"medium"}
                      disableRipple
                    />
                  )}
                />
              }
              label="فعال"
              labelPlacement="end"
            />
          </Grid>
          <Grid item xs={12} sm={1}>
            <Button type="submit" variant="contained" color="secondary">جستجو</Button>
          </Grid>
        </Grid>
        <MaterialReactTable table={table} />
      </RtlProvider>
    </form>
  );
}

export default HotelPanel;
